// extracted by mini-css-extract-plugin
module.exports = {"side-menu":"style_side-menu__3I3De","tabs":"style_tabs__drGQ7","iframe-cont":"style_iframe-cont__qahtB"};